//main.js
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
window.__BUILD_ID__ = "1.0.0";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "./assets/scss/main.scss";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faStar as farStar,
  faHeart as farHeart,
  faTrashAlt as farTrashAlt,
} from "@fortawesome/free-regular-svg-icons";
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowDown,
  faBan,
  faBars,
  faBell,
  faBold,
  faBookmark,
  faCalendarDay,
  faCaretDown,
  faCaretUp,
  faCheck,
  faCheckCircle,
  faClock,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronLeft,
  faChevronRight,
  faDownload,
  faEllipsisV,
  faExclamation,
  faExclamationCircle,
  faExpand,
  faEye,
  faFileAlt,
  faGripVertical,
  faHeart,
  faImage,
  faImages,
  faItalic,
  faKey,
  faLink,
  faList,
  faListOl,
  faPaperPlane,
  faPen,
  faPlay,
  faPlayCircle,
  faPlus,
  faPlusCircle,
  faQuestion,
  faSearch,
  faSort,
  faSortAlphaDown,
  faSortAlphaUp,
  faStar,
  faThumbtack,
  faTimes,
  faTrashAlt,
  faUnderline,
  faUpload,
  faUser,
} from "@fortawesome/free-solid-svg-icons";

// import { faHeart } from "@fortawesome/free-regular-svg-icons";
import Storage from "vue-ls";
import { apolloProvider } from "./vue-apollo";
import { InMemoryCache } from "apollo-cache-inmemory";
import "croppie/croppie.css";
import VueMask from "v-mask";
import Paginate from "vuejs-paginate";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import "vue-select/dist/vue-select.css";
import ProgressBar from "vuejs-progress-bar";
import { es } from "@braid/vue-formulate-i18n";
import ChileanRutify from "chilean-rutify";

// Import VueTippy synchronously to register directive immediately
import VueTippy, { TippyComponent } from "vue-tippy";
import { opcionesFocoTippy } from "./utils/tippy";
// Import vSelect synchronously to avoid component resolution issues
import vSelect from "vue-select";
import FormulateVSelect from "./components/ui/FormulateVSelect.vue";

Vue.use(VueToast);
Vue.component("paginate", Paginate);
const options = {
  namespace: "vuejs__", // key prefix
  name: "ls", // name variable Vue.[ls] or this.[$ls],
  storage: "local", // storage name session, local, memory
};
const options_vue_progressBar = {
  color: "#bffaf3",
  failedColor: "#874b4b",
  thickness: "5px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300,
  },
  autoRevert: true,
  location: "left",
  inverse: false,
};

library.add(
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowDown,
  faBan,
  faBars,
  faBell,
  faBold,
  faBookmark,
  faCalendarDay,
  faCaretDown,
  faCaretUp,
  faCheck,
  faCheckCircle,
  faClock,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronLeft,
  faChevronRight,
  faDownload,
  faEllipsisV,
  faExclamation,
  faExclamationCircle,
  faExpand,
  faEye,
  faFileAlt,
  faGripVertical,
  faHeart,
  faImage,
  faImages,
  faItalic,
  faKey,
  faLink,
  faList,
  faListOl,
  faPaperPlane,
  faPen,
  faPlay,
  faPlayCircle,
  faPlus,
  faPlusCircle,
  faQuestion,
  farHeart,
  farStar,
  farTrashAlt,
  faSearch,
  faSort,
  faSortAlphaDown,
  faSortAlphaUp,
  faStar,
  faThumbtack,
  faTimes,
  faTrashAlt,
  faUnderline,
  faUpload,
  faUser
);

Vue.use(VueMask);
Vue.use(Storage, options);
Vue.use(ProgressBar);

// Register VueTippy synchronously to avoid directive resolution issues
Vue.use(VueTippy, {
  defaultProps: { placement: "top" },
  popperOptions: {
    modifiers: {
      preventOverflow: {
        enabled: false,
      },
      hide: { enabled: false },
    },
  },
  // Que el foco que devuelve Bootstrap al cerrar un modal no deje el tooltip abierto
  ...opcionesFocoTippy,
});
Vue.component("tippy", TippyComponent);

// Register vSelect synchronously
Vue.component("v-select", {
  extends: vSelect,
  render(h) {
    const slots = this.$scopedSlots;
    if (!slots["no-options"] && Object.isExtensible(slots)) {
      slots["no-options"] = () => "Búsqueda sin resultados.";
    }
    return vSelect.render.call(this, h);
  },
});
// v-select dentro de vue-formulate: <FormulateInput type="vselect" />, ver
// library en Vue.use(VueFormulate) más abajo.
Vue.component("FormulateVSelect", FormulateVSelect);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.prototype.$noResults = "No se han encontrado resultados para tu búsqueda";

const cache = new InMemoryCache({
  User: {
    keyFields: [],
  },
});

Vue.config.productionTip = false;

import moment from "moment-timezone";

// main.js
import { apolloClientCC, apolloClient } from "./vue-apollo.js";
import { borrarMarcaSesion, motivoCierreSesion } from "./utils/sesion";
import { SEGMENTACIONES } from "./utils/terminos";

// Función para carga perezosa de librerías pesadas
async function loadHeavyPlugins(store = null) {
  try {
    const [
      VCalendar,
      { default: VueApexCharts },
      { default: VueCroppie },
      { default: VueProgressBar },
      { default: VueSplide },
      { default: VueFormulate },
    ] = await Promise.all([
      import(/* webpackChunkName: "plg-v-calendar" */ "v-calendar"),
      import(/* webpackChunkName: "plg-apexcharts" */ "vue-apexcharts"),
      import(/* webpackChunkName: "plg-croppie" */ "vue-croppie"),
      import(/* webpackChunkName: "plg-progressbar" */ "vue-progressbar"),
      import(/* webpackChunkName: "plg-splide" */ "@splidejs/vue-splide"),
      import(/* webpackChunkName: "plg-formulate" */ "@braid/vue-formulate"),
    ]);

    // Configurar Vue.use() para cada plugin
    Vue.use(VCalendar.default || VCalendar, {
      componentPrefix: "v",
    });
    Vue.use(VueApexCharts);
    Vue.use(VueCroppie);
    Vue.use(VueProgressBar, options_vue_progressBar);
    Vue.use(VueSplide);
    Vue.use(VueFormulate, {
      plugins: [es],
      locale: "es",
      rules: {
        validRut: ({ value }) => ChileanRutify.validRut(value),
      },
      locales: {
        es: {
          validRut: () => `RUT inválido.`,
          required: () => `Campo requerido.`,
          email: () => `El correo no está bien formado.`,
          confirm: () => `Las contraseñas no coinciden.`,
          min: ({ args }) =>
            `La contraseña debe tener al menos ${args[0]} caracteres.`,
          matches: () =>
            `La contraseña debe tener al menos un número, una mayúscula y un caracter especial.`,
        },
      },
      classes: {
        errors: "validation-messages",
      },
      library: {
        vselect: {
          classification: "select",
          component: "FormulateVSelect",
        },
      },
    });
    Vue.component("apexchart", VueApexCharts);

    // Asegurar que los componentes de VCalendar estén registrados
    if (VCalendar.default) {
      Vue.component("VDatePicker", VCalendar.default.DatePicker);
      Vue.component("v-date-picker", VCalendar.default.DatePicker);
    } else if (VCalendar.DatePicker) {
      Vue.component("VDatePicker", VCalendar.DatePicker);
      Vue.component("v-date-picker", VCalendar.DatePicker);
    }

    if (store) {
      Vue.nextTick(() => {
        store.dispatch("setHeavyLibrariesLoaded", true);
      });
    }
  } catch (error) {
    console.error("Error cargando librerías pesadas:", error);
    // Opcional: mostrar un toast de error al usuario
    if (Vue.prototype.$toast) {
      Vue.prototype.$toast.open({
        message:
          "Error cargando algunos componentes. Algunas funcionalidades pueden no estar disponibles.",
        type: "warning",
        duration: 5000,
        position: "top-right",
      });
    }
  }
}

Vue.mixin({
  computed: {
    // La identidad del usuario vive en loginModule (store/modules/login/storeLogin.js).
    // Atajos disponibles en todo componente, para no repetir
    // mapGetters("loginModule", ...) en cada archivo ni leer $ls.get("user").
    idEmpresa() {
      return this.$store.getters["loginModule/idEmpresa"];
    },
    idUsuario() {
      return this.$store.getters["loginModule/idUsuario"];
    },
    identidad() {
      return this.$store.getters["loginModule/identidad"];
    },
    usuarioActual() {
      return this.$store.getters["loginModule/usuario"];
    },
    empresaActual() {
      return this.$store.getters["loginModule/empresa"] || {};
    },
    idPrivilegio() {
      return this.$store.getters["loginModule/idPrivilegio"];
    },
    idGrupo() {
      return this.$store.getters["loginModule/idGrupo"];
    },
    colorPrimario() {
      return this.$store.getters["loginModule/colorPrimario"];
    },
    estaLogueado() {
      return this.$store.getters["loginModule/estaLogueado"];
    },
    // Nombre de cada segmentación en la empresa del usuario (utils/terminos.js):
    // GERENCIA, SUCURSAL, SINDICATO, GENERO, NACION, TURNO, SOCIEDAD y CARGO.
    // En un template: {{ SUCURSAL.plural }}, `Selecciona ${GERENCIA.un} ${GERENCIA.singular}`.
    // Son computed para que los textos cambien cuando llegan los términos, que
    // es después del primer render. Una propiedad del componente con el mismo
    // nombre (en data, computed o props) tapa a la global.
    ...Object.keys(SEGMENTACIONES).reduce((computeds, clave) => {
      computeds[clave] = function () {
        return this.$store.state.terminos.porClave[clave];
      };
      return computeds;
    }, {}),
  },
  methods: {
    // Término de la segmentación con ese id (1 → gerencia), para los nombres
    // que llegan por id desde un catálogo. undefined si el id no es una
    // segmentación: quien llama decide el texto de respaldo.
    terminoPorId(id) {
      return this.$store.getters["terminos/terminoPorId"](id);
    },
    logOut() {
      apolloClient.clearStore();
      apolloClient.resetStore();
      apolloClientCC.clearStore();
      apolloClientCC.resetStore();
      if (apolloClient.link.subscriptionClient) {
        apolloClient.link.subscriptionClient.close();
      }
      localStorage.clear();
      sessionStorage.clear();
      borrarMarcaSesion();
      this.$store.commit("loginModule/CLEAR_USER_DATA");
      this.$router.push({ name: "Login" }).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          throw err;
        }
      });
    },
    // Al cargar la app: cierra la sesión guardada si el token venció o si no se
    // marcó "Recordar sesión" y el navegador se cerró desde el login. Con la app
    // abierta lo vigila App.vue. Ver utils/sesion.js.
    checkSessionExpiration() {
      if (!motivoCierreSesion(this.$ls.get("remember_session"))) return false;
      this.logOut();
      return true;
    },
    // vue-router 3 rechaza la promesa de push() cuando la navegación se
    // cancela, se redirige o es a la ruta actual. Nada de eso es un error para
    // el usuario, pero sin catch aparece en consola como promesa no capturada.
    // Los fallos del router traen _isRouter; cualquier otra cosa se relanza.
    irA(destino) {
      return this.$router.push(destino).catch((err) => {
        if (!err || !err._isRouter) throw err;
      });
    },
    redirectToLoneModule(modules) {
      if (modules.some((module) => module.moduloGeneral.id_modulo === "1")) {
        this.irA({ name: "Inicio" });
        return;
      }
      if (modules.some((module) => module.moduloGeneral.id_modulo === "24")) {
        this.irA({ path: "/CanalCorporativo" });
        return;
      }

      this.irA({ path: modules[0].moduloGeneral.ruta_admin });
    },

    dateFormatymd(dateString) {
      if (
        dateString != "Inicio" &&
        dateString != "Término" &&
        dateString != "Termino"
      ) {
        const date = moment.utc(dateString);
        if (date.isValid()) {
          return date.format("DD/MM/YYYY");
        } else {
          return "Sin información";
        }
      } else {
        return dateString;
      }
    },
    dateFormatymdhours(dateString, format = "DD/MM/YYYY HH:mm") {
      if (
        dateString !== "Inicio" &&
        dateString !== "Término" &&
        dateString !== "Termino"
      ) {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const date = moment.tz(dateString, timezone); // Cambia a moment.tz y usa la zona horaria detectada
        if (date.isValid()) {
          return date.format(format);
        } else {
          return "Sin información";
        }
      } else {
        return dateString;
      }
    },
    formatDateToUTC(dateStr, format = "YYYY-MM-DD HH:mm") {
      const date = moment.utc(dateStr);
      return date.format(format);
    },
    convertToUTCStartOfDay(dateString) {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const date = moment.tz(dateString, timezone);
      return date.utc().format("YYYY-MM-DD HH:mm:ss");
    },

    nowChileMoment() {
      return moment().tz("America/Santiago");
    },

    areEqual(...objects) {
      return objects.every(
        (obj) => JSON.stringify(obj) === JSON.stringify(objects[0])
      );
    },

    darkenHexColor(hex) {
      // Remove the hash at the start if it's there
      hex = hex.replace(/^#/, "");

      // Parse the hex into RGB components
      let r = parseInt(hex.substring(0, 2), 16);
      let g = parseInt(hex.substring(2, 4), 16);
      let b = parseInt(hex.substring(4, 6), 16);

      // Decrease each component according to the percent to darken
      r = parseInt(r * (1 - 0.1)).toString(16);
      g = parseInt(g * (1 - 0.1)).toString(16);
      b = parseInt(b * (1 - 0.1)).toString(16);

      // Ensure 2 digits by adding a zero if necessary
      r = r.length === 1 ? "0" + r : r;
      g = g.length === 1 ? "0" + g : g;
      b = b.length === 1 ? "0" + b : b;

      return "#" + r + g + b;
    },

    decodeJWT(token) {
      const parts = token.split(".");
      if (parts.length !== 3) {
        console.error("Token no tiene formato de JWT");
      }
      // const header = JSON.parse(atob(parts[0]));
      const payload = JSON.parse(atob(parts[1]));
      return payload;
    },

    toastGenericError() {
      this.$toast.open({
        message:
          "Error obteniendo información. Por favor recarga la página e intenta nuevamente.",
        type: "error",
        duration: 5000,
        position: "top-right",
      });
    },
    toastStatusChangeSuccess() {
      this.$toast.open({
        message: "Se ha cambiado el estado correctamente.",
        type: "success",
        duration: 5000,
        position: "top-right",
      });
    },
    toastStatusChangeError() {
      this.$toast.open({
        message:
          "Ocurrió un error al cambiar el estado. Por favor inténtalo nuevamente.",
        type: "error",
        duration: 5000,
        position: "top-right",
      });
    },
    toastServerError() {
      this.$toast.open({
        message:
          "Operación fallida. Por favor inténtalo nuevamente o contáctate con nosotros.",
        type: "error",
        duration: 5000,
        position: "top-right",
      });
    },
    capitalizeFirstLetter(texto) {
      return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();
    },
  },
});

// Directiva personalizada para detectar clicks afuera de elementos
Vue.directive("click-outside", {
  bind: function (element, binding, vnode) {
    //check that click was outside the el and his children
    element.clickOutsideEvent = function (event) {
      // and if it did, call method provided in attribute value
      if (!(element === event.target || element.contains(event.target))) {
        vnode.context[binding.expression](event);
        // binding.value(); run the arg
      }
    };
    document.body.addEventListener("click", element.clickOutsideEvent);
  },
  unbind: function (element) {
    document.body.removeEventListener("click", element.clickOutsideEvent);
  },
});

const app = new Vue({
  router,
  store,
  cache,
  apolloProvider,
  watch: {
    $route: {
      handler(to) {
        document.title = to.meta.title || "KAIK";
      },
      immediate: true,
    },
  },
  render: (h) => h(App),
});

app.checkSessionExpiration();

app.$mount("#app");

Vue.nextTick(() => {
  loadHeavyPlugins(app.$store);
});
